import { TABS_CONFIG } from "@pma/utils/constants";
import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

interface TabsStore {
  tabs: {
    "project-detail": [];
    settings: [];
    boq: [];
    "main-boq": [];
    contractor: [];
    tasks: string[];
    finance: string[];
  };
  addTab: (context: TabType, tab: string) => void;
  removeTab: (context: TabType, tab: string) => void;
  hydrated: boolean;
}

export type TabType =
  | "project-detail"
  | "settings"
  | "boq"
  | "main-boq"
  | "contractor"
  | "finance"
  | "tasks";

export const useTabsStore = create<TabsStore>()(
  devtools(
    persist(
      (set, get) => ({
        tabs: {
          tasks: [],
          finance: [],
          "project-detail": [],
          settings: [],
          boq: [],
          "main-boq": [],
          contractor: [],
        },
        hydrated: false,
        addTab: (context: TabType, tab: string) => {
          set((state) => ({
            tabs: {
              ...state.tabs,
              [context]: [...state.tabs[`${context}`], tab],
            },
          }));
        },
        removeTab: (context: TabType, tab: string) => {
          set((state) => ({
            tabs: {
              ...state.tabs,
              [context]: state.tabs[`${context}`].filter((activeTab) => activeTab !== tab),
            },
          }));
        },
      }),

      {
        name: TABS_CONFIG,
        onRehydrateStorage: (state) => {
          if (state) {
            state.hydrated = true;
          }
        },
      },
    ),
  ),
);
